import { render, staticRenderFns } from "./DTimer.vue?vue&type=template&id=2ce3b3fc&lang=pug"
import script from "./DTimer.vue?vue&type=script&lang=js"
export * from "./DTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports